'use strict';

export default function MobileNavigationCtrl (
  $rootScope,
  mobileNavigationMenu,
  userModel,
  logout,
  guideStatus,
  dashboard,
  becomeGuide,
  currencyOptions,
  currencyModel
) {
  'ngInject';

  this.userModel = userModel;
  this.guideStatus = guideStatus;
  this.dashboard = dashboard;
  this.becomeGuide = becomeGuide;
  this.currencies = currencyOptions;
  this.currency = currencyModel.getValue();

  this.logout = function () {
    logout();
    this.close();
  };

  this.close = function () {
    mobileNavigationMenu.hide();
  };

  $rootScope.$on('$stateChangeSuccess', this.close.bind(this));

}



// WEBPACK FOOTER //
// ./app/src/common/mobile_navigation_menu/mobile_navigation_menu.controller.js